import AmazonCheckout from './AmazonCheckout';

import { connect } from 'react-redux';

import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import get from 'lodash/get';
import withProps from 'recompose/withProps';
import withState from 'recompose/withState';

import withCountry from '../../../hocs/withCountry';
import withQueryParams from '../../../hocs/withQueryParams';
import formatPrismicData from '../../../hocs/formatPrismicData';
import withErrorTranslations from '../../../hocs/withErrorTranslations';
import { withModel } from 'src/client/js/view/data-providers/model';

import { updateAmazonShippingDetails } from '../../../../store/thunks/cart';
import { getTotalPrice } from '../../../../store/selectors/cart';
import { getUserDetails, checkoutDetails } from '../../../../store/selectors/checkoutDetails';
import { getCheckoutDetails } from '../../../../store/thunks/checkoutDetails';

import { getCookies } from 'src/client/js/facades/eagle/helpers/cookies';
import { fetchAmazonSettings } from 'src/common/facades/eagle/checkout';
import { localiseUrl } from 'src/common/utils/format-localised-url';

import payWithAmazon from './helpers';
import logger from 'src/logger';

const enhance = compose(
  formatPrismicData,
  withModel,
  withErrorTranslations,
  withCountry,
  withQueryParams,
  connect(
    state => ({
      total: getTotalPrice(state),
      checkout: checkoutDetails(state).checkout,
      currentUser: getUserDetails(state),
    }),
    (dispatch, { sendErrorMessage, country: countryModel }) => ({
      getCheckoutDetails: () => dispatch(getCheckoutDetails(getCookies())),
      updateAmazonShippingDetails: (orderReferenceId, accessToken) =>
        (dispatch(updateAmazonShippingDetails(
          orderReferenceId,
          accessToken,
          {
            cookies: getCookies(),
            countryModel,
            sendErrorMessage
          },
        ))),
    })
  ),
  withState('amazonSettings', 'setAmazonSettings'),
  withState('orderReference', 'setOrderReference'),
  withState('amazonAuthentication', 'setAmazonAuthentication'),
  withState('addressPreviouslySubmitted', 'setAddressPreviouslySubmitted', false),
  withState('fetchingShippingMethods', 'setFetchingShippingMethods', false),
  withState('isSubmitting', 'setIsSubmitting', false),
  withState('isOptInChecked', 'setIsOptInChecked', null),
  lifecycle({
    async componentDidMount() {
      const { queryParams: { error: queryError }, ...props } = this.props;


      if (!props.clientId || !props.merchantId) {
        const amazonSettings = await fetchAmazonSettings(getCookies());
        props.setAmazonSettings(amazonSettings);
      }

      if (queryError) {
        props.sendErrorMessage(error => error.payment[queryError] || error.http['500']);
      }
    },
  }),
  withProps(props => ({
    agreementType: 'OrderReference',
    scope: 'profile postal_code payments:widget payments:shipping_address',
    // These two are actually used by the amazon pay react library, do NOT remove!
    handleBillingAgreementId: () => {},
    onOrderReferenceCreate: (orderRefContainer) => {
      const orderReference = orderRefContainer.getAmazonOrderReferenceId();
      if (orderReference !== props.orderReference) {
        props.setOrderReference(orderReference);
      }
    },
    billingAgreementId: null,
    onConsentChange: null,
    useAmazonAddressBook: true,
    handleWalletError: (err) => {
      logger.warn(`Amazon Error: ${err.getErrorCode()}: ${err.getErrorMessage()}`);
      window.location.reload();
    },
    clientId: get(props, 'amazonSettings.clientId'),
    merchantId: get(props, 'amazonSettings.merchantId'),
    scaEnabled: get(props, 'amazonSettings.sca'),
    widgetUrl: get(props, 'amazonSettings.widgetUrl'),
    isSandbox: get(props, 'amazonSettings.isSandbox'),
    shippingMethodsForm: {
      ...props.shippingMethodsForm,
      body: props.shippingMethodsForm.body.filter(field => field.type !== 'submit')
    }
  })),
  withHandlers({
    handleOptInClick: props => event => {
      props.setIsOptInChecked(event.target.checked);
    },
    handlePaymentConfirmation: ({
      setIsSubmitting,
      scaEnabled,
      orderReference: amazonOrderRef,
      merchantId: amazonMerchantId,
      isOptInChecked: marketingOptIn,
      sendErrorMessage,
      country,
      checkout
    }) => async () => {
      const failureUrl = window.location.href;
      const successRedirectUrl = localiseUrl(country, `/orders/${checkout.id}`);
      await payWithAmazon({
        setIsSubmitting,
        amazonOrderRef,
        failureUrl,
        amazonMerchantId,
        scaEnabled,
        marketingOptIn,
        sendErrorMessage,
        nativeAmazonClient: window.OffAmazonPayments,
        successRedirectUrl,
      });
    },
    handleAddressSelection: props => async () => {
      const accessToken = props.amazonAuthentication.access_token;
      const orderReferenceId = props.orderReference;

      props.setFetchingShippingMethods(true);
      await props.updateAmazonShippingDetails(orderReferenceId, accessToken);
      props.setFetchingShippingMethods(false);

      if (!props.addressPreviouslySubmitted) {
        // If the address has never been submitted before then this method is being called by the selected
        // address that Amazon has chosen. If that's the case then we want to get the user details based on the
        // order that they have. This will happen once, only when Amazon widget first loads.
        const { payload: { checkout: { marketingOptIn } = {} } } = await props.getCheckoutDetails();
        if (!marketingOptIn) {
          props.setIsOptInChecked(marketingOptIn !== false ? props.isOptInPreChecked : false);
        }
        props.setAddressPreviouslySubmitted(true);
      }
    },
  })
);

export default enhance(AmazonCheckout);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/Amazon/index.js